import { messenger as base } from '../base';
import { messenger as AT } from './AT';
import { messenger as CZ } from './CZ';
import { messenger as HU } from './HU';
import { messenger as SK } from './SK';
import { messenger as HR } from './HR';
import { messenger as RO } from './RO';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    HU,
    SK,
    HR,
    RO,
};
